import { StorageState } from '../../../../reducers';
import { createDataFetchSliceSelectors } from '../../../../utils/dataFetch';


export const accountsClaimsListSliceSelector = (state: StorageState) => state.accounts.claims.list;

export const accountsClaimsListSelectors = createDataFetchSliceSelectors(
    accountsClaimsListSliceSelector,
);
